// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"bbd91b5d","259":"356ba771","453":"5a111d56","566":"6adf7557","933":"3dd96e67"}[chunkId] + ".chunk.js";
};